//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

export enum CampaignsCreatorsSortKey {
  Recent = 'Recent',
  Content = 'Content',
  Impressions = 'Impressions',
  Engagement = 'Engagement',
  EMV = 'EMV',
  OnsiteRevenue = 'OnsiteRevenue',
  FixedPay = 'FixedPay',
}
